import React from 'react';
import { BaasicTableActionsTemplate } from 'themes/components';

function BaasicTableActions(props) {
    return (
        <BaasicTableActionsTemplate {...props} />
    )
}

export default BaasicTableActions;